<template>
  <!-- <div class="home-container">
    <div class="home-text">name:{{ name }}</div>
    <div class="home-text">roles:<span v-for="role in roles" :key="role">{{ role }}</span></div>
  </div>-->
  <hm-content title="预约日历" class="home-content" v-if="!isAdmin">
    <div class="flex home-container">
      <div class="calendar-out-wrapper">
        <hm-calendar @selectDay="selectDay"></hm-calendar>
      </div>
      <div>
        <ul class="order-list" v-if="calendarDayAppointment.length">
          <li class="flex" v-for="(v, i) in calendarDayAppointment" :key="i">
            <div class="order-count flex flex-center flex-column">
              <span>{{ v.serverName }}</span>
              <div class="count">
                <strong>{{ v.num }}</strong
                >单
              </div>
            </div>
            <div class="order-table">
              <div class="table-header flex">
                <span>时间段</span>
                <span>预约技师</span>
                <span>预约门店</span>
                <span>会员姓名</span>
                <span>手机号</span>
                <span>备注</span>
              </div>
              <div class="table-body">
                <div
                  class="order-item flex item-center"
                  v-for="(item, index) in v.serverList"
                  :key="index"
                >
                  <span>{{ item.startDateFormat }}</span>
                  <span>{{ item.serverGuider }}</span>
                  <span>{{ item.storeOutlet }}</span>
                  <span>{{ item.realName }}</span>
                  <span>{{ item.mobilePhone }}</span>
                  <span>{{ item.description }}</span>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <div v-else>今日没有预约</div>
      </div>
    </div>
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="600px"
    >
      <el-scrollbar
        wrap-class="service-scroll"
        wrap-style="height: 500px; overflow-x:hidden"
        :native="false"
      >
        <div class="ql-container">
          <div class="ql-editor" v-html="content"></div>
        </div>
      </el-scrollbar>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="dialogVisible = false" size="small" type="primary"
          >关闭</el-button
        >
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
import hmCalendar from "@/components/HmCalendar";

import { getLoginUser } from "@/utils/auth";
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  name: "home",
  components: { hmCalendar },
  computed: {
    ...mapGetters(["name", "roles", "calendarDayAppointment"])
  },
  data() {
    return {
      isAdmin: false,
      dialogVisible: false,
      title: "",
      content: ""
    };
  },
  created() {
    this.checkShowNotice();
  },
  methods: {
    checkShowNotice() {
      // 检测是否从登录界面跳转到本页
      const { from } = this.$route.query;
      if (from === "login") {
        const role = getLoginUser().roles[0];
        if (role === "admin") {
          this.isAdmin = true;
        } else {
          this.$store.dispatch("showNotice").then(res => {
            const { status, remindType, title, content } = res.result;
            if (status) {
              if (status === 1 && remindType === 0) {
                localStorage.removeItem("invalidDate");
                this.showModal({
                  title,
                  content
                });
              } else if (status === 1 && remindType === 1) {
                const invalidDate = localStorage.getItem("invalidDate");
                if (!invalidDate) {
                  if (status === 1) {
                    this.showModal({
                      title: title,
                      content
                    });
                  }
                  localStorage.setItem(
                    "invalidDate",
                    moment()
                      .add(1, "days")
                      .format("YYYY-MM-DD")
                  );
                }
              }
            }
          });
        }
      }
    },
    showModal({ dialogVisible = true, title, content }) {
      this.dialogVisible = dialogVisible;
      this.content = content;
      this.title = title;
    },
    selectDay({ startTime }) {
      if (!this.isAdmin) {
        this.$store.dispatch("queryCalendarDayAppointment", { startTime });
      }
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss">
.home-container {
  overflow-x: scroll;
}

.home-content {
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }
}
</style>
<style rel="stylesheet/scss" lang="scss" scoped>
.count {
  strong {
    font-size: 20px;
    color: #e50065;
  }
}
.order-list {
  li {
    border: 1px solid #ebeef5;
    font-size: 14px;
    margin-bottom: 10px;
    .order-count {
      text-align: center;
      border-right: 1px solid #ebeef5;
      box-sizing: border-box;
      width: 100px;
    }
    .table-header {
      border-bottom: 1px solid #ebeef5;
      line-height: 23px;
      box-sizing: border-box;
      background: #f5f7fa;
      span {
        padding: 12px 0;
        height: 100%;
        width: 120px;
        text-align: center;
        border-right: 1px solid #ebeef5;
        line-height: 20px;
      }
      span:last-child {
        border-right: 0;
      }
    }
    .order-item {
      > span {
        padding: 12px 0;
        height: 100%;
        width: 120px;
        text-align: center;
        border-right: 1px solid #ebeef5;
      }
      button {
        padding: 0;
      }
      span:last-child {
        border-right: 0;
      }
    }
    .order-item:not(:last-child) {
      border-bottom: 1px solid #ebeef5;
    }
    .order-item:hover {
      background-color: #f5f7fa;
    }
  }
}

.calendar-out-wrapper {
  margin-right: 2rem;
  margin-bottom: 2rem;
}

.service-scrolll::-webkit-scrollbar-thumb {
  background-color: #808080;
  border-radius: 3px;
}
</style>
